import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useSignup } from "../hooks/useSignup";
import "../Components/Login/Login.css";
import { FaExclamationCircle } from "react-icons/fa";

const SignupPage = () => {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [formError, setFormError] = useState("");
  const { signup, success, loading, error } = useSignup();
  const navigate = useNavigate();

  useEffect(() => {
    if (success) {
      navigate("/");
    }
  }, [success, navigate]);

  const handleSubmit = (e) => {
    e.preventDefault();
    setFormError("");

    if (!name || !email || !password || !confirmPassword) {
      setFormError("Por favor, preencha todos os campos para criar sua conta.");
      return;
    }

    if (password !== confirmPassword) {
      setFormError("As senhas não coincidem. Por favor, verifique e tente novamente.");
      return;
    }

    if (password.length < 6) {
      setFormError("A senha deve ter pelo menos 6 caracteres.");
      return;
    }

    signup({ name, email, password });
  };

  const ErrorMessage = ({ message }) => (
    <div className="error-message">
      <FaExclamationCircle />
      <p className="error-message-text">{message}</p>
    </div>
  );

  return (
    <div className="login-container">
      <img src="imgs/reino_header_logo.svg" alt="Reinoplay Logo" className="login-logo" />
      <form onSubmit={handleSubmit} className="login-form-vertical">
        <input
          type="text"
          placeholder="Nome"
          className="login-input"
          value={name}
          onChange={(e) => setName(e.target.value)}
        />
        <input
          type="email"
          placeholder="Email"
          className="login-input"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />
        <input
          type="password"
          placeholder="Senha"
          className="login-input"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
        />
        <input
          type="password"
          placeholder="Confirmar senha"
          className="login-input"
          value={confirmPassword}
          onChange={(e) => setConfirmPassword(e.target.value)}
        />

        {(formError || error) && (
          <ErrorMessage message={formError || error} />
        )}

        <button className="login-button" type="submit" disabled={loading}>
          {loading ? "Cadastrando..." : "Criar conta"}
        </button>

        <button
          type="button"
          className="login-forgot"
          style={{ marginTop: 8 }}
          onClick={() => navigate("/login")}
        >
          Já tenho conta
        </button>
      </form>
    </div>
  );
};

export default SignupPage; 